/* tslint:disable */
/* eslint-disable */
/**
 * Modulos Platform API v2
 * API for the Modulos Platform.
 *
 * The version of the OpenAPI document: 2.5.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateTestingTestRequest } from '../model';
// @ts-ignore
import type { HTTPValidationError } from '../model';
// @ts-ignore
import type { TestingTest } from '../model';
// @ts-ignore
import type { TestingTestResult } from '../model';
// @ts-ignore
import type { UpdateTestingTestRequest } from '../model';
/**
 * TestingTestApi - axios parameter creator
 */
export const TestingTestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Testing Test
         * @param {string} projectId 
         * @param {CreateTestingTestRequest} createTestingTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingTest: async (projectId: string, createTestingTestRequest: CreateTestingTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTestingTest', 'projectId', projectId)
            // verify required parameter 'createTestingTestRequest' is not null or undefined
            assertParamExists('createTestingTest', 'createTestingTestRequest', createTestingTestRequest)
            const localVarPath = `/testing/tests/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTestingTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Testing Test Result
         * @param {string} testId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingTestResult: async (testId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('createTestingTestResult', 'testId', testId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('createTestingTestResult', 'projectId', projectId)
            const localVarPath = `/testing/tests/{test_id}/results`
                .replace('{test_id}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Testing Test
         * @param {string} testId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTest: async (testId: string, projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('getTestingTest', 'testId', testId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('getTestingTest', 'projectId', projectId)
            const localVarPath = `/testing/tests/{test_id}`
                .replace('{test_id}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Testing Test
         * @param {string} testId 
         * @param {string} projectId 
         * @param {UpdateTestingTestRequest} updateTestingTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestingTest: async (testId: string, projectId: string, updateTestingTestRequest: UpdateTestingTestRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('updateTestingTest', 'testId', testId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('updateTestingTest', 'projectId', projectId)
            // verify required parameter 'updateTestingTestRequest' is not null or undefined
            assertParamExists('updateTestingTest', 'updateTestingTestRequest', updateTestingTestRequest)
            const localVarPath = `/testing/tests/{test_id}`
                .replace('{test_id}', encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication HTTPBearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (projectId !== undefined) {
                localVarQueryParameter['project_id'] = projectId;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTestingTestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestingTestApi - functional programming interface
 */
export const TestingTestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestingTestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Testing Test
         * @param {string} projectId 
         * @param {CreateTestingTestRequest} createTestingTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestingTest(projectId: string, createTestingTestRequest: CreateTestingTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestingTest(projectId, createTestingTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingTestApi.createTestingTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Testing Test Result
         * @param {string} testId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTestingTestResult(testId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTestResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTestingTestResult(testId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingTestApi.createTestingTestResult']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Testing Test
         * @param {string} testId 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTestingTest(testId: string, projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTestingTest(testId, projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingTestApi.getTestingTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Testing Test
         * @param {string} testId 
         * @param {string} projectId 
         * @param {UpdateTestingTestRequest} updateTestingTestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTestingTest(testId: string, projectId: string, updateTestingTestRequest: UpdateTestingTestRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestingTest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTestingTest(testId, projectId, updateTestingTestRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TestingTestApi.updateTestingTest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TestingTestApi - factory interface
 */
export const TestingTestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestingTestApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Testing Test
         * @param {TestingTestApiCreateTestingTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingTest(requestParameters: TestingTestApiCreateTestingTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTest> {
            return localVarFp.createTestingTest(requestParameters.projectId, requestParameters.createTestingTestRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Testing Test Result
         * @param {TestingTestApiCreateTestingTestResultRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTestingTestResult(requestParameters: TestingTestApiCreateTestingTestResultRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTestResult> {
            return localVarFp.createTestingTestResult(requestParameters.testId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Testing Test
         * @param {TestingTestApiGetTestingTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTestingTest(requestParameters: TestingTestApiGetTestingTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTest> {
            return localVarFp.getTestingTest(requestParameters.testId, requestParameters.projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Testing Test
         * @param {TestingTestApiUpdateTestingTestRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTestingTest(requestParameters: TestingTestApiUpdateTestingTestRequest, options?: RawAxiosRequestConfig): AxiosPromise<TestingTest> {
            return localVarFp.updateTestingTest(requestParameters.testId, requestParameters.projectId, requestParameters.updateTestingTestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for createTestingTest operation in TestingTestApi.
 */
export interface TestingTestApiCreateTestingTestRequest {
    readonly projectId: string

    readonly createTestingTestRequest: CreateTestingTestRequest
}

/**
 * Request parameters for createTestingTestResult operation in TestingTestApi.
 */
export interface TestingTestApiCreateTestingTestResultRequest {
    readonly testId: string

    readonly projectId: string
}

/**
 * Request parameters for getTestingTest operation in TestingTestApi.
 */
export interface TestingTestApiGetTestingTestRequest {
    readonly testId: string

    readonly projectId: string
}

/**
 * Request parameters for updateTestingTest operation in TestingTestApi.
 */
export interface TestingTestApiUpdateTestingTestRequest {
    readonly testId: string

    readonly projectId: string

    readonly updateTestingTestRequest: UpdateTestingTestRequest
}

/**
 * TestingTestApi - object-oriented interface
 */
export class TestingTestApi extends BaseAPI {
    /**
     * 
     * @summary Create Testing Test
     * @param {TestingTestApiCreateTestingTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestingTest(requestParameters: TestingTestApiCreateTestingTestRequest, options?: RawAxiosRequestConfig) {
        return TestingTestApiFp(this.configuration).createTestingTest(requestParameters.projectId, requestParameters.createTestingTestRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Testing Test Result
     * @param {TestingTestApiCreateTestingTestResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createTestingTestResult(requestParameters: TestingTestApiCreateTestingTestResultRequest, options?: RawAxiosRequestConfig) {
        return TestingTestApiFp(this.configuration).createTestingTestResult(requestParameters.testId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Testing Test
     * @param {TestingTestApiGetTestingTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getTestingTest(requestParameters: TestingTestApiGetTestingTestRequest, options?: RawAxiosRequestConfig) {
        return TestingTestApiFp(this.configuration).getTestingTest(requestParameters.testId, requestParameters.projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Testing Test
     * @param {TestingTestApiUpdateTestingTestRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public updateTestingTest(requestParameters: TestingTestApiUpdateTestingTestRequest, options?: RawAxiosRequestConfig) {
        return TestingTestApiFp(this.configuration).updateTestingTest(requestParameters.testId, requestParameters.projectId, requestParameters.updateTestingTestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

